import { render, staticRenderFns } from "./CdkCard.vue?vue&type=template&id=374c56e4&scoped=true&"
import script from "./CdkCard.vue?vue&type=script&lang=js&"
export * from "./CdkCard.vue?vue&type=script&lang=js&"
import style0 from "./CdkCard.vue?vue&type=style&index=0&id=374c56e4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c56e4",
  null
  
)

export default component.exports